import page from '../../pages/Page.module.css';

export type AcceptedBidInfo = {
  revisionId?: number;
  revision?: number;
  acceptedAt?: string;
};

export function AcceptedBidBanner({ acceptedBid }: { acceptedBid?: AcceptedBidInfo | null }) {
  if (!acceptedBid?.revision) return null;
  const when = acceptedBid.acceptedAt
    ? new Date(acceptedBid.acceptedAt).toLocaleString()
    : null;
  return (
    <div
      className={page.card}
      style={{
        marginBottom: 'var(--space-md)',
        borderLeft: '4px solid var(--color-brand)',
        padding: 'var(--space-sm) var(--space-md)',
      }}
      role="status"
    >
      <strong>Accepted bid — Revision {acceptedBid.revision}</strong>
      {when ? (
        <span className={page.muted} style={{ display: 'block', marginTop: 4, fontSize: 14 }}>
          Accepted {when}. Edits are locked until acceptance is cleared on the Project Profitability tab.
        </span>
      ) : (
        <span className={page.muted} style={{ display: 'block', marginTop: 4, fontSize: 14 }}>
          Edits are locked until acceptance is cleared on the Project Profitability tab.
        </span>
      )}
    </div>
  );
}
